/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CorporationInvoice } from './CorporationInvoice';
import {
    CorporationInvoiceFromJSON,
    CorporationInvoiceFromJSONTyped,
    CorporationInvoiceToJSON,
} from './CorporationInvoice';

/**
 * 
 * @export
 * @interface CorporationBatchAdd
 */
export interface CorporationBatchAdd {
    /**
     * 
     * @type {CorporationInvoice}
     * @memberof CorporationBatchAdd
     */
    invoice: CorporationInvoice;
    /**
     * 
     * @type {string}
     * @memberof CorporationBatchAdd
     */
    email?: CorporationBatchAddEmailEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CorporationBatchAdd
     */
    emails: Array<string>;
}


/**
 * @export
 */
export const CorporationBatchAddEmailEnum = {
    Code: 'code',
    Subscription: 'subscription'
} as const;
export type CorporationBatchAddEmailEnum = typeof CorporationBatchAddEmailEnum[keyof typeof CorporationBatchAddEmailEnum];


/**
 * Check if a given object implements the CorporationBatchAdd interface.
 */
export function instanceOfCorporationBatchAdd(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "invoice" in value;
    isInstance = isInstance && "emails" in value;

    return isInstance;
}

export function CorporationBatchAddFromJSON(json: any): CorporationBatchAdd {
    return CorporationBatchAddFromJSONTyped(json, false);
}

export function CorporationBatchAddFromJSONTyped(json: any, ignoreDiscriminator: boolean): CorporationBatchAdd {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'invoice': CorporationInvoiceFromJSON(json['invoice']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'emails': json['emails'],
    };
}

export function CorporationBatchAddToJSON(value?: CorporationBatchAdd | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'invoice': CorporationInvoiceToJSON(value.invoice),
        'email': value.email,
        'emails': value.emails,
    };
}

